import styles from "./index.module.less";
function Logo() {
  return <div className={styles.logo}>甘肃省政务信息报送系统</div>;
}

export default Logo;
